// Resolve a Firebase Storage download URL from a `storagePath` field.
//
// Day Final fix: <audio src=...> with a raw REST URL does NOT carry the
// Firebase auth header, so Storage Rules see request.auth == null and
// reject with 403 even for signed-in users. Use getDownloadURL which
// returns a URL with a long-lived download token embedded in the query
// string — <audio> / <img> can fetch it without any auth header.
//
// Lives in @goodbye/firebase (not an app) so both the learner and worker
// apps can resolve echo / audio download URLs from the same helper.

import { getDownloadURL, ref } from "firebase/storage";
import { getFirebase } from "./client";

export async function storageUrl(path: string): Promise<string> {
  if (!path) return "";
  const storage = getFirebase().storage;
  return getDownloadURL(ref(storage, path));
}
